import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Icon } from '@haldor/ui';
import './Collapsible.scss';
var Collapsible = /*#__PURE__*/function (_Component) {
  function Collapsible(props) {
    var _this;
    _classCallCheck(this, Collapsible);
    _this = _callSuper(this, Collapsible, [props]);
    _defineProperty(_this, "_setContent", function (element) {
      return _this.content = element;
    });
    _defineProperty(_this, "_setContainer", function (element) {
      return _this.container = element;
    });
    /* Lifecycle methods */
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.open != null) {
        if (nextProps.open != _this.state.open) {
          _this.toggle();
        }
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.open == true || _this.props.defaultOpen == true) {
        _this.container.style.height = 'auto';
        _this.container.style.overflow = 'visible';
      }
    });
    /* Events */
    _defineProperty(_this, "toggle", function (event) {
      if (event != null) {
        event.preventDefault();
      }
      _this.setState({
        open: !_this.state.open
      }, function () {
        if (_this.state.open) {
          _this.container.style.height = _this.content.clientHeight + 'px';

          // Animation timing: Fire after CSS transition is completed
          setTimeout(function () {
            _this.container.style.height = 'auto';
            _this.container.style.overflow = 'visible';
          }, _this.animationLength);
        } else {
          _this.container.style.height = _this.content.clientHeight + 'px';
          _this.container.style.overflow = 'hidden';

          // Set height 0 to animate collapsing
          setTimeout(function () {
            _this.container.style.height = '0px';
          }, 35);
        }
        if (_this.props.onChange != null) {
          _this.props.onChange(_this.state.open);
        }
      });
    });
    var open = false;
    if (props.open != null) {
      open = props.open;
    } else {
      if (props.defaultOpen != null) {
        open = props.defaultOpen;
      }
    }
    _this.state = {
      open: open
    };
    _this.content = null;
    _this.container = null;
    _this.animationLength = 270;
    return _this;
  }
  _inherits(Collapsible, _Component);
  return _createClass(Collapsible, [{
    key: "render",
    value: /* Render methods */
    function render() {
      var open = this.state.open;
      return /*#__PURE__*/React.createElement("div", {
        className: open ? 'collapsible open' : 'collapsible'
      }, this.props.trigger != null ? /*#__PURE__*/React.createElement("div", {
        className: "collapsible-trigger",
        onClick: this.toggle
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, typeof this.props.trigger === 'function' ? this.props.trigger(open) : this.props.trigger, this.props.badge != null ? /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.badge) : null))) : null, /*#__PURE__*/React.createElement("div", {
        ref: this._setContainer,
        className: "collapsible-content"
      }, /*#__PURE__*/React.createElement("div", {
        ref: this._setContent
      }, this.props.children)));
    }
  }]);
}(Component);
export default Collapsible;